import NiceModal from "@ebay/nice-modal-react";
import { Stack, TableCell, TableRow } from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useIsDesktop } from "../../../hooks";
import { AccordionsMobileSlideUpProps } from "../../AccordionsMobileSlideUp";
import { Modals } from "../../Modals";
import { ParseValue } from "../TableHelpers";
import { BasicRowProps } from "../TableTypesExtended";
import * as Styled from "./BasicTableComponents.styled";

export const BasicTableRow: FC<BasicRowProps> = (props) => {
    const isDesktop = useIsDesktop();

    return isDesktop ? <DesktopRow {...props} /> : <MobileRow {...props} />;
};

const DesktopRow: FC<BasicRowProps> = ({ data, alignRightIndex, types, rowKey }: BasicRowProps) => {
    const row = data[rowKey];

    return (
        <TableRow key={rowKey}>
            {Array.isArray(row) &&
                row.map((val, cellKey) => (
                    <TableCell key={cellKey} align={cellKey >= alignRightIndex ? "right" : "inherit"}>
                        {ParseValue(val, types[cellKey])}
                    </TableCell>
                ))}
        </TableRow>
    );
};

const MobileRow: FC<BasicRowProps> = ({
    title,
    priorityCol,
    translateRoute,
    data,
    types,
    rowKey,
    columnTitles,
}: BasicRowProps) => {
    const { t } = useTranslation();
    const row = data[rowKey];

    const openRow = (title: React.ReactNode, content: React.ReactNode) => {
        NiceModal.show(Modals.ModalSlideUp, {
            title: title,
            content: <>{content}</>,
        });
    };

    const handleClick =
        data[0].length > 2
            ? () => openRow(arr[0].rows[rowKey].popUpContentTitle, arr[0].rows[rowKey].popUpContent)
            : undefined;

    const arr: AccordionsMobileSlideUpProps["accordions"] = useMemo(() => {
        return [
            {
                title: "",
                rows: data.map((row, index) => ({
                    title: columnTitles[index],
                    popUpContentTitle: title ? "Detail - " + title : null,
                    popUpContent: (
                        <>
                            {row.map((item, index) => (
                                <Styled.MobileRowWrapper
                                    key={index}
                                    $hasUnderline={index !== data.length}
                                    direction={"row"}
                                >
                                    <Stack>
                                        {translateRoute
                                            ? t(`${translateRoute}.${columnTitles[index]}`)
                                            : columnTitles[index]}
                                    </Stack>
                                    <Stack>{ParseValue(item, types[index])}</Stack>
                                </Styled.MobileRowWrapper>
                            ))}
                        </>
                    ),
                })),
            },
        ];
    }, [data]);

    return (
        <TableRow key={rowKey} onClick={handleClick}>
            <TableCell>{ParseValue(row[0], types[0])}</TableCell>
            <TableCell align="right">{ParseValue(row[priorityCol], types[priorityCol])}</TableCell>
            <Styled.IconTableCell>{data[0].length > 2 ? <Styled.SelectArrowOrange /> : null}</Styled.IconTableCell>
        </TableRow>
    );
};
